<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="~@/common/imgs/honor.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>荣誉资质</h3>
            <p>Honorary Certificate</p>
          </dt>
          <dd class="w33">
            <router-link :to="{path: '/HonorMention',query:{id: '1'}}" :class="this.$route.query.id == '1' ? 'active' : ''"><span>企业资质</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w33">
            <router-link :to="{path: '/HonorMention',query:{id: '2'}}" :class="this.$route.query.id == '2' ? 'active' : ''"><span>企业荣誉</span><i
                class="el-icon-arrow-right"></i></router-link>
          </dd>
          <dd class="w33">
            <router-link to="PjHonor" :class="{active: false}"><span>工程荣誉</span><i class="el-icon-arrow-right"></i></router-link>
          </dd>
        </dl>
      </div>
      <div class="news-right">
        <div class="news-bread">
          <h2>荣誉资质</h2>/<i>{{pageName}}</i>
        </div>
        <div class="honor-scroll">
          <el-carousel :interval="4000" type="card" height="320px">
            <el-carousel-item v-for="item in honorList" :key="item.id" :label="item.title">
              <!-- <img :src="url + item.cmAttachmentInformation.baiUrl" :alt="item.nwiTitle"> -->
              <viewer :images="honorList"><img :src="item.attachmentVos[0].fileVo.url">
              </viewer>
            </el-carousel-item>
          </el-carousel>
        </div>

        <el-divider></el-divider>

        <div class="honor-namelist">
          <ul>
            <li v-for="item in honorList" :key="item.id"><i class="el-icon-trophy"></i>{{item.title}}</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'HonorMention',
    data() {
      return {
        url: global_msg.baseUrl,
        honorList: [],
        pageName: '',
      }
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    created() {
      this.loadPage();
    },
    mounted() {},
    watch: {
      '$route': 'loadPage'
    },
    methods: {
      loadPage() {
        var id = 0;
        if (this.$route.query.id == 1) {
          this.pageName = '企业资质';
          id = 16;
          axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=企业资质').then((response) => {
            this.honorList = response.data.subject.result;
          });
        } else {
          this.pageName = '企业荣誉';
          id = 17;
          axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=企业荣誉').then((response) => {
            this.honorList = response.data.subject.result;
          });
        }
        // axios.get(global_msg.baseUrl + 'ntWebsiteinfo/findHonor?nwcId=' + id +
        //   '&page=1&rows=200&nwiIsShow=1').then((response) => {
        //   this.honorList = response.data.rows;
        // });

      }
    }
  }
</script>

<style>
  @media screen and (max-width: 1120px) {
    #footer {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HonorMention.vue